// extracted by mini-css-extract-plugin
export var cardTitle = "OfferSliderCard-module--card-title--fcd83";